/*
 * @Author: caiqin.xie
 * @since: 2023-07-20 14:27:48
 * @lastTime: 2023-07-20 14:35:36
 * @LastEditors: caiqin.xie
 * @message: 
 */
const img_pic_l = require('../../../../../static/images/game_pic_l.jpg')
const img_pic = require(`../../../../../static/images/game_pic.jpg`)

export default [
  {
    id: '1',
    gameImg: img_pic_l,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '2',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '3',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  { 
    id: '4',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '5',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '6',
    gameImg: img_pic_l,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '7',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '8',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '9',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '10',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '11',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '12',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '13',
    gameImg: img_pic_l,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '14',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '15',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '16',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '17',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '18',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '19',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '20',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  },
  {
    id: '21',
    gameImg: img_pic,
    title: 'Final Fantasy 14',
    content: 'The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn"'
  }
]